/** One section heading parsed from the document, in document order. */
export interface DocumentHeading {
  /** Markdown heading level (2 = `##`, 3 = `###`, 4 = `####`). */
  level: number;
  text: string;
}

/**
 * Extracts h2–h4 section headings from a Markdown string, in document order, for the table of
 * contents. Lines inside ``` fences (pmc-figure / pmc-table directives) are skipped so a `#`
 * inside a directive body is never mistaken for a heading. The returned order matches the
 * `<h2>`/`<h3>`/`<h4>` order react-markdown renders, so a TOC entry's index maps 1:1 to the
 * rendered heading element at the same index.
 */
export function parseHeadings(markdown: string): DocumentHeading[] {
  const headings: DocumentHeading[] = [];
  let inFence = false;
  for (const line of markdown.split("\n")) {
    if (line.startsWith("```")) {
      inFence = !inFence;
      continue;
    }
    if (inFence) continue;
    const match = /^(#{2,4})\s+(.+?)\s*#*$/.exec(line);
    if (match) headings.push({ level: match[1].length, text: match[2].trim() });
  }
  return headings;
}
